<template>
  <layout>
    <div slot="content">
      <i-card title="用户列表">
        <div slot="content">
          <el-form :inline="true" size="small" style="text-align: right">
            <el-form-item>
              <el-input v-model="filter.mobile" placeholder="手机号码" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="filter.default_linker" placeholder="联系人姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="是否合伙人" style="width: 175px" clearable v-model="filter.is_team">
                <el-option label="是合伙人" value="1"></el-option>
                <el-option label="非合伙人" value="-1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="会员组" style="width: 175px" clearable v-model="filter.group_id">
                <el-option :label="item.name" :value="item.id" v-for="item in groupList"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getUserList">查找</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table v-loading="loading" :data="userList" :border="true">
            <el-table-column prop="default_linker" width="150" label="默认联系人"/>
            <el-table-column prop="mobile" width="150" label="手机号码"/>
            <el-table-column prop="openid" width="260" label="openid"/>
            <el-table-column label="合伙人" width="80" prop="user_flag">
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="(scope.row.user_flag & 1)===1">是</el-tag>
                <el-tag size="mini" type="danger" v-else>否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="钱包余额" width="100" prop="purse_total"/>
            <el-table-column label="会员组" width="100" prop="group_name"/>
            <el-table-column label="登录IP" width="150" prop="ip"/>
            <el-table-column label="上次登录" width="200" prop="last_login"/>
            <el-table-column label="操作" width="250" fixed="right">
              <div slot-scope="scope" class="opt-container">
                <el-button size="mini" type="primary" @click="showGroupList(scope.row)">设置会员组</el-button>
                <el-button size="mini" type="primary" @click="getTeam(scope.row)">合伙人列表
                </el-button>
              </div>
            </el-table-column>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :current-page="pageInfo.current_page" layout="prev, pager, next" :page-size="15"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
      <!--设置会员组-->
      <el-dialog title="提示" :visible.sync="showGroup" width="20%">
        <div>
          <el-select v-model="currUser.group_id" placeholder="请选择会员组" style="width: 100%">
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showGroup = false">取 消</el-button>
          <el-button type="primary" @click="setUserGroup" :loading="postLoading">确 定</el-button>
        </div>
      </el-dialog>
      <!--合伙人列表-->
      <el-dialog title="合伙人列表" :visible.sync="showTeam" width="50%">
        <div>
          <el-table :data="teamList" :border="true">
            <el-table-column prop="avatar" width="80" label="头像">
              <div slot-scope="scope">
                <img :src="scope.row.avatar" width="50" height="50">
              </div>
            </el-table-column>
            <el-table-column prop="nickname" label="昵称"/>
            <el-table-column prop="created_at" label="加入时间"/>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :current-page="teamPageInfo.current_page" layout="prev, pager, next"
                           :page-size="15" @current-change="changeTeamListPage" :total="teamPageInfo.total"/>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showTeam = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "user-list",
  data() {
    return {
      userList: [],
      loading: false,
      postLoading: false,
      pageInfo: {
        current_page: 1,
        total: 0
      },
      teamPageInfo: {
        current_page: 1,
        total: 0
      },
      showGroup: false,
      showTeam: false,
      currUser: {},
      groupList: [],
      filter: {
        nickname: "",
        is_team: "",
        group_id: "",
        default_linker: "",
        mobile: "",
      },
      teamList: []
    }
  },
  methods: {
    getUserList: function () {
      this.loading = true;
      this.$http.request('userList', {page: this.pageInfo.current_page, filter: this.filter}).then(res => {
        this.userList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
      })
    },
    getTeam: function (userInfo) {
      this.showTeam = true;
      if (userInfo) {
        this.teamPageInfo.current_page = 1;
        this.currUser = userInfo;
      }
      this.$http.request('teamList', {uuid: this.currUser.uuid, page: this.teamPageInfo.current_page}).then(res => {
        this.teamList = res.data;
        this.teamPageInfo = res.meta;
      })
    },
    changeTeamListPage: function (page) {
      this.teamPageInfo.current_page = page;
      this.getTeam();
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getUserList();
      window.scrollTo(0, 0);
    },
    getGroupList: function () {
      this.$http.request('groupList').then(res => {
        this.groupList = res.data;
      });
    },
    showGroupList: function (userInfo) {
      this.showGroup = true;
      this.currUser = userInfo;
    },
    setUserGroup: function () {
      this.postLoading = true;
      this.$http.request('setUserGroup', {
        group_id: this.currUser.group_id,
        uuid: this.currUser.uuid
      }).then(res => {
        this.postLoading = false;
        if (res.status === 'success') {
          this.$message({message: res.message, type: 'success'});
          this.showGroup = false;
        }
      });
    },
    reset: function () {
      window.location.reload();
    }
  },
  created: function () {
    this.getUserList();
    this.getGroupList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/user-list.vue